'use strict'
import Masonry from 'masonry-layout'
import {bootstrap} from '../bootstrap/bootstrap'

const grid = document.querySelector('.masonry-grid')

bootstrap(grid, grid => {
  const msnry = new Masonry(grid, {
    itemSelector: '.tile',
    columnWidth: 280,
    gutter: 20,
    transitionDuration: 0,
    initLayout: false
  })

  msnry.once('layoutComplete', () => {
    grid.classList.add('load')
  })

  return msnry.layout()
})
